module.exports = __webpack_public_path__ + "img/placeholder.87df7dba.png";